export interface Country {
  name: string;
  code: string;
  dial_code: string;
  flag: string;
}

const ALL_COUNTRIES: Country[] = require('../../assets/countries.json');

const LATAM_CODES = [
  'AR',
  'BR',
  'CL',
  'CO',
  'CR',
  'EC',
  'SV',
  'GT',
  'HN',
  'MX',
  'NI',
  'PA',
  'PY',
  'PE',
  'UY',
  'VE',
];

const LATAM_COUNTRIES = ALL_COUNTRIES.filter((c) =>
  LATAM_CODES.includes(c.code)
);

export function validateCandidateCountry(
  jobCountries: string[] | null | undefined,
  candidateCountry: string,
  candidateCode?: string
): string | null {
  if (!jobCountries || jobCountries.length === 0) {
    return null;
  }
  if (jobCountries.includes('LATAM')) {
    const match = LATAM_COUNTRIES.find(
      (c) =>
        c.name.toLowerCase() === candidateCountry.toLowerCase() ||
        c.code === candidateCode
    );
    if (!match) {
      return 'Our client is only accepting candidates from LATAM';
    }
    return null;
  }
  const candidateMatch = jobCountries.some(
    (country) =>
      country.toLowerCase() === candidateCountry.toLowerCase() ||
      country.toUpperCase() === candidateCode
  );
  if (!candidateMatch) {
    return `Our client is only accepting candidates from ${jobCountries.join(', ')}`;
  }
  return null;
}
